const brandColors = {
  white: '#ffffff',
  purpleTelus: '#4b286d',
  greenTelus: '#66cc00',
  greenAccessible: '#2b8000',
  purpleDark: '#3f2a54',
  purpleEminence: '#613889',
  purpleDeluge: '#7c53a5',
  purplePaleLavender: '#D6CDE3',
  greenDarkFern: '#163e06',
  greenSanFelix: '#1f5c09',
  greenMutedGreen: '#8cbf8c',
  greenYellow: '#bfe797',
  greenTusk: '#e3f6d1',
  greenPanache: '#f4f9f2',
}

const neutralColors = {
  greyThunder: '#2c2e30',
  greyCharcoal: '#414547',
  greyShuttle: '#676e73',
  greyCloud: '#b2b9bf',
  greyMystic: '#e3e6e8',
  greyAthens: '#f4f4f7',
  greyAlabaster: '#fafafa',
}

const notificationColors = {
  redDark: '#c12335',
  red: '#e12339',
  redLight: '#fff6f8',
  lightPink: '#f5d5d5',
  amberDark: '#b4872c',
  amber: '#faca69',
  amberLight: '#fff9ee',
  disableAmber: '#f7e2a5',
}

const textColors = {
  purpleTelus: '#4b286d',
  greyThunder: '#2c2e30',
  greyCharcoal: '#414547',
  greyShuttle: '#676e73',
  white: '#ffffff',
  greenAccessible: '#2b8000',
}

const backgroundColors = {
  white: '#ffffff',
  greyAthens: '#f4f4f7',
  greyMystic: '#e3e6e8',
  greyShuttle: '#676e73',
  greyCharcoal: '#414547',
  greyThunder: '#2c2e30',
  black: '#000000',
  purpleTelus: '#4b286d',
  redDark: '#c12335',
  redLight: '#fff6f8',
  amberLight: '#fff9ee',
  greenPanache: '#f4f9f2',
  purpleGradient: 'linear-gradient(135deg, #4b286d 75%, #e53293)',
  purpleGradientBadge: 'linear-gradient(135deg, #4b286d 40%, #e53293)',
}

const iconColors = {
  purpleTelus: '#4b286d',
  greyCharcoal: '#414547',
  greyShuttle: '#676e73',
  redDark: '#c12335',
  amberDark: '#b4872c',
  greenAccessible: '#2b8000',
  redDarker: '#560c0c',
}

const opacityColors = {
  transparent: 'rgba(0, 0, 0, 0)',
  light97: 'rgba(255, 255, 255, 0.97)',
  light80: 'rgba(255, 255, 255, 0.8)',
  light60: 'rgba(255, 255, 255, 0.6)',
  light40: 'rgba(255, 255, 255, 0.4)',
  light20: 'rgba(255, 255, 255, 0.2)',
  light10: 'rgba(255, 255, 255, 0.1)',
  dark97: 'rgba(0, 0, 0, 0.97)',
  dark80: 'rgba(0, 0, 0, 0.8)',
  dark60: 'rgba(0, 0, 0, 0.6)',
  dark40: 'rgba(0, 0, 0, 0.4)',
  dark20: 'rgba(0, 0, 0, 0.2)',
  dark10: 'rgba(0, 0, 0, 0.1)',
}

const gradientColors = {
  purpleGradient: 'linear-gradient(135deg, #4b286d, 75%, #e53293)',
  greenGradient: 'linear-gradient(135deg, #00784a, 75%, #66cc00)',
  brandGradient: 'linear-gradient(135deg, #4b286d, 75%, #613889)',
  baseGradient: 'radial-gradient(44.58% 44.58% at 81.13% 36.79%, #ffffff 0%, #f4f4f7 100%)',
  neutralGradient: 'linear-gradient(180deg, #ffffff, #f4f4f7)',
  eminenceToPaleLavender: 'linear-gradient(135deg, #613889, #D6CDE3)',
  sanFelixToMutedGreen: 'linear-gradient(135deg, #1f5c09, #8cbf8c)',
  darkFernToPanache: 'linear-gradient(135deg, #163e06, #f4f9f2)',
  delugeToEminence: 'linear-gradient(135deg, #7c53a5, #613889)',
  telusGreenToYellowGreen: 'linear-gradient(135deg, #66cc00, #bfe797)',
  thunderGreyToAlabaster: 'linear-gradient(135deg, #2c2e30, #fafafa)',
  charcoalGreyToCloudGrey: 'linear-gradient(135deg, #414547, #b2b9bf)',
}

const badgeColors = {
  purpleTelus: '#4b286d',
  greenTelus: '#66cc00',
  darkPurple: '#3a2156',
  lightPurple: '#7a5a9c',
  darkGreen: '#509a00',
  lightGreen: '#85d13b',
  complementaryBlue: '#2a3b6d',
  complementaryYellow: '#d1b800',
  deepPurple: '#35214c',
  softPurple: '#9168ad',
  mutedGreen: '#79b300',
  paleGreen: '#a8e300',
  brightBlue: '#3366cc',
  teal: '#008080',
  warmYellow: '#ffcc33',
  softPink: '#cc6699',
  burntOrange: '#cc5500',
  redDark: '#c12335',
  red: '#e12339',
  purpleEminence: '#613889',
  purpleDeluge: '#7c53a5',
  purplePaleLavender: '#D6CDE3',
  greenDarkFern: '#163e06',
  greenSanFelix: '#1f5c09',
  greenMutedGreen: '#8cbf8c',
}

export {
  brandColors,
  neutralColors,
  notificationColors,
  textColors,
  backgroundColors,
  iconColors,
  opacityColors,
  gradientColors,
  badgeColors,
}
